<template>
  <v-row class="section">
    <v-container>
      <!-- Años -->
      <v-expansion-panels v-model="expandedYear">
        <v-expansion-panel
          v-for="(yearData, yIndex) in model.years"
          :key="yearData.year"
          :value="yIndex"
        >
          <v-expansion-panel-title>
            <v-icon start icon="mdi-folder"></v-icon>
            Año {{ yearData.year }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <!-- Meses -->
            <v-expansion-panels v-model="expandedMonth[yearData.year]">
              <v-expansion-panel
                v-for="month in 12"
                :key="month"
                :value="month"
                @group:selected="fetchCAs(yearData.year, month)"
              >
                <v-expansion-panel-title>
                  <v-icon start icon="mdi-folder"></v-icon>
                  {{ model.monthNames[month - 1] }}
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <!-- Loader -->
                  <div v-if="loadingMonths[`${yearData.year}-${month}`]" class="d-flex justify-center pa-4">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </div>

                  <!-- Sin datos -->
                  <div v-else-if="!casMap[`${yearData.year}-${month}`] || casMap[`${yearData.year}-${month}`].length === 0" class="text-center pa-4">
                    <em>Sin datos</em>
                  </div>

                  <!-- Listado de CAs -->
                  <v-expansion-panels v-else v-model="expandedCA[`${yearData.year}-${month}`]">
                    <v-expansion-panel
                      v-for="caName in casMap[`${yearData.year}-${month}`]"
                      :key="caName"
                      :value="caName"
                      @group:selected="fetchFiles(yearData.year, month, caName)"
                    >
                      <v-expansion-panel-title>
                        <v-icon start icon="mdi-certificate"></v-icon>
                        {{ caName }}
                      </v-expansion-panel-title>

                      <v-expansion-panel-text>
                        <!-- Loader -->
                        <div v-if="loadingCAs[`${yearData.year}-${month}-${caName}`]" class="d-flex justify-center pa-4">
                          <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </div>

                        <!-- Tabla de archivos -->
                        <v-table
                          v-else
                          density="compact"
                          class="w-auto"
                        >
                          <thead>
                            <tr>
                              <th class="text-left">This Update</th>
                              <th class="text-left">Next Update</th>
                              <th class="text-left"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in filesMap[`${yearData.year}-${month}-${caName}`] || []"
                              :key="item.link"
                            >
                              <td>{{ item.thisUpdate }}</td>
                              <td>{{ item.nextUpdate }}</td>
                              <td>
                                <v-btn
                                  icon="mdi-download"
                                  variant="text"
                                  size="small"
                                  :href="baseUrl + item.link"
                                  :download="item.name"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-alert v-if="loadError" type="error" class="mt-4">
        Error loading data. Please try again later.
      </v-alert>
    </v-container>
  </v-row>
</template>

<script>
import config from "@/store/config";
import axios from "axios";

export default {
  name: "HomeView",
  data() {
    return {
      expandedYear: null,
      expandedMonth: {},
      expandedCA: {},
      loadingYears: {},
      loadingMonths: {},
      loadingCAs: {},
      casMap: {},      // year-month -> lista de CAs
      filesMap: {},    // year-month-ca -> lista de archivos
      model: {
        years: [],
        monthNames: [
          "Enero", "Febrero", "Marzo", "Abril",
          "Mayo", "Junio", "Julio", "Agosto",
          "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ]
      },
      loadError: false,
      baseUrl: null
    };
  },
  mounted() {
    this.baseUrl = config.baseUrl;
    this.years();
  },
  methods: {
    async years() {
      try {
        const yearsResponse = await axios.get(`${this.baseUrl}/crl-service/history/years`);
        const years = yearsResponse.data;
        this.model.years = years.sort((a, b) => b - a).map((year) => ({ year }));
        if (years.length > 0) {
          this.expandedYear = 0;
        }
      } catch (error) {
        console.error("Error fetching years:", error);
        this.loadError = true;
      }
    },

    async fetchCAs(year, month) {
      const key = `${year}-${month}`;
      if (this.casMap[key]) return; // ya cargado
      this.loadingMonths[key] = true;
      try {
        const res = await axios.get(`${this.baseUrl}/crl-service/history/cas`, {
          params: { year, month }
        });
        this.casMap[key] = res.data || [];
      } catch (e) {
        console.error(`Error fetching CAs for ${key}:`, e);
        this.casMap[key] = [];
      } finally {
        this.loadingMonths[key] = false;
      }
    },

    async fetchFiles(year, month, caName) {
      const key = `${year}-${month}-${caName}`;
      if (this.filesMap[key]) return; // ya cargado
      this.loadingCAs[key] = true;
      try {
        const res = await axios.get(`${this.baseUrl}/crl-service/history/list`, {
          params: { year, month, ca: caName }
        });
        this.filesMap[key] = res.data || [];
      } catch (e) {
        console.error(`Error fetching files for ${key}:`, e);
        this.filesMap[key] = [];
      } finally {
        this.loadingCAs[key] = false;
      }
    }
  }
};
</script>

<style scoped>
.section {
  background-color: #f2f2f2;
  padding: 0px;
}
</style>
